// 오늘의집 광고비 계산기 — 사장님이 넣은 숫자만으로 계약 1건 비용을 낸다(빌드파이 요금은 넣지 않는다).

export interface OhouseCostInput {
  monthlyAd: number;
  monthlyContracts: number;
  avgContractAmount: number;
  /** 마진율 0~1 (0.15 = 15%). */
  marginRate: number;
}

export interface OhouseCostResult {
  /** 계약 1건에 든 광고비. 계약이 0건이면 null. */
  costPerContract: number | null;
  /** 계약 1건 비용 ÷ 평균 계약금액. 계약금액이 0이면 null. */
  shareOfContract: number | null;
  /** 계약 1건 비용 ÷ 계약 1건 이익. 이익이 0이면 null. */
  shareOfProfit: number | null;
  /** 계약 1건 이익(평균 계약금액 × 마진율). */
  profitPerContract: number;
  /** 자사 채널로 계약 1건이 오면 그만큼 광고비 없이 받은 계약(광고비 자체는 그대로 나간다). */
  adFreeMonthly: number | null;
  adFreeYearly: number | null;
}

const clean = (n: number): number => (Number.isFinite(n) && n > 0 ? n : 0);

export const ohouseCost = (input: OhouseCostInput): OhouseCostResult => {
  const ad = clean(input.monthlyAd);
  const contracts = clean(input.monthlyContracts);
  const avg = clean(input.avgContractAmount);
  const margin = Math.min(clean(input.marginRate), 1);
  const costPerContract = contracts > 0 ? Math.round(ad / contracts) : null;
  const profitPerContract = Math.round(avg * margin);
  return {
    costPerContract,
    shareOfContract: costPerContract !== null && avg > 0 ? costPerContract / avg : null,
    shareOfProfit: costPerContract !== null && profitPerContract > 0 ? costPerContract / profitPerContract : null,
    profitPerContract,
    adFreeMonthly: costPerContract,
    adFreeYearly: costPerContract === null ? null : costPerContract * 12,
  };
};

// 「15」·「15.5%」 → 0.15·0.155. 숫자가 없거나 음수면 0, 100 을 넘으면 1.
export const parsePercent = (text: string): number => {
  if (text.includes("-")) return 0;
  const n = Number(text.replace(/[^\d.]/g, ""));
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(n, 100) / 100;
};

// 계약 건수 — 소수 허용(「월 1.5건」). 숫자가 아니거나 음수면 0.
export const parseCount = (text: string): number => {
  if (text.includes("-")) return 0;
  const n = Number(text.replace(/[^\d.]/g, ""));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
